import React, { useState } from "react";
import { Redirect } from "react-router";
import "./style.css";
import cancel from "../../../utils/assests/error.png";
import Header from "../../../Common/header";

import { Button, Typography } from "@material-ui/core";
// import { Box } from "@material-ui/core";
import Box from '@mui/material/Box';

function SorryPage() {
  const [click, setClick] = useState(false);

  const handleClick = () => {
    setClick(true);
  };

  return (
    <Box
      className="appPendigContainer d-flex flex-column justify-content-between"
      sx={{ pt: 5, justifyContent: "space-between", flexDirection: "column" }}
    >
      {click ? <Redirect to="/dashboard" /> : ""}

      <div id="sorryCard" style={{ textAlign: "center" }}>
        <img src={cancel} alt="error_img" />
      </div>

      <div style={{ textAlign: "center" }}>
        <Box component="div">
          <Typography variant="h6">Sorry</Typography>
        </Box>
        <Box component="div" mt={5}>
          <Typography>
            Thank you for cooperating,we cannot finace you at this time{" "}
          </Typography>
        </Box>
      </div>

      <Box id="buttonId" sx={{ mt: 20, textAlign: "center" }}>
        <Button
          variant="contained"
          color="secondary"
          className="redButton"
          id="buttonSID"
          onClick={handleClick}
        >
          Go to Dashboard
        </Button>
      </Box>
    </Box>
  );
}

export default SorryPage;
